function getOrCreateElement(parent, tagName, className) {
  let element = parent.querySelector(`.${className}`);
  if (!element) {
    element = document.createElement(tagName);
    element.className = className;
    parent.appendChild(element);
  }
  return element;
}

function setupTextWithLink(banner, textBanner) {
  let anchor = textBanner.querySelector('a');
  if (!anchor) {
    textBanner.innerHTML = '';
    anchor = document.createElement('a');
    textBanner.appendChild(anchor);
  }
  const styles = {
    fontSize: `${banner.dataset.fontSize}px`,
    color: `${banner.dataset.fontColor}`,
    padding: `${banner.dataset.paddingTopAndBottom}px ${banner.dataset.paddingLeftAndRight}px`,
    backgroundColor: banner.dataset.backgroundColor,
  };
  Object.assign(anchor.style, styles);
  anchor.href = banner.dataset.linkUrl;
  anchor.textContent = banner.dataset.sectionText;
}

function setupTextBanner(banner) {
  const existingImgBanner = banner.querySelector('.img-banner');
  if (existingImgBanner) {
    existingImgBanner.remove();
  }
  const textBanner = getOrCreateElement(banner, 'div', 'text-banner');
  if (banner.dataset.linkUrl) {
    setupTextWithLink(banner, textBanner);
  } else {
    textBanner.innerHTML = banner.dataset.sectionText;
  }
}

function getOrCreateAnchor(banner, parent) {
  let anchor = parent.querySelector('a');
  if (!anchor) {
    anchor = document.createElement('a');
    parent.appendChild(anchor);
  }
  const anchorStyles = {
    display: 'block',
    color: banner.dataset.fontColor,
    height: `${banner.dataset.imageHeight}px`,
  };
  Object.assign(anchor.style, anchorStyles);
  anchor.href = banner.dataset.linkUrl;
  return anchor;
}

function getOrCreateImageSection(banner, parent) {
  let imageSection = parent.querySelector('.image-section');
  if (!imageSection) {
    imageSection = document.createElement('div');
    imageSection.className = 'image-section';
    parent.appendChild(imageSection);
  }
  return imageSection;
}

function applyImageSectionStyles(banner, imageSection) {
  const styles = {
    padding: `${banner.dataset.paddingTopAndBottom}px 0`,
    backgroundImage: `url(${banner.dataset.bannerImage})`,
    height: banner.dataset.imageHeight,
  };
  Object.assign(imageSection.style, styles);
}

function removeTextBanner(banner) {
  const textBanner = banner.querySelector('.text-banner');
  if (textBanner) {
    textBanner.remove();
  }
}

function removeImgBanner(banner) {
  const imgBanner = banner.querySelector('.image-section');
  if (imgBanner) {
    imgBanner.remove();
  }
}

function setupImageWithLink(banner, imgBanner) {
  const anchor = getOrCreateAnchor(banner, imgBanner);
  const imageSection = getOrCreateImageSection(banner, anchor);
  applyImageSectionStyles(banner, imageSection);
}

function setupImageWithoutLink(banner, imgBanner) {
  const existingAnchor = banner.querySelector('a');
  if (existingAnchor) {
    existingAnchor.remove();
  }
  const imageSection = getOrCreateImageSection(banner, imgBanner);
  applyImageSectionStyles(banner, imageSection);
}

function setupImageBanner(banner) {
  removeTextBanner(banner);
  removeImgBanner(banner);
  const imgBanner = getOrCreateElement(banner, 'div', 'img-banner');
  if (banner.dataset.linkUrl) {
    setupImageWithLink(banner, imgBanner);
  } else {
    setupImageWithoutLink(banner, imgBanner);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!navigator.userAgent.includes('Yappli')) return;
  const banners = document.querySelectorAll('.generic-banner');
  banners.forEach((banner) => {
    if (banner.dataset.showApp !== 'true') {
      banner.remove();
      return;
    }
    const styles = {
      fontSize: `${banner.dataset.fontSize}px`,
      color: banner.dataset.fontColor,
      padding: `${banner.dataset.paddingTopAndBottom}px ${banner.dataset.paddingLeftAndRight}px`,
      margin: `${banner.dataset.marginTopAndBottom}px 0`,
      backgroundColor: banner.dataset.backgroundColor,
    };
    Object.assign(banner.style, styles);
    if (banner.dataset.useImg === 'true') {
      setupImageBanner(banner);
    } else {
      setupTextBanner(banner);
    }
  });
});
